export const UPDATE_CASINO_GAMES = 'UPDATE_CASINO_GAMES';
export const UPDATE_IND_CASINO_GAMES = 'UPDATE_IND_CASINO_GAMES';